let runtimeConfig = { env: {} };

export const setRuntimeConfig = (key, value) => {
  runtimeConfig[key] = value;
};

export const getRuntimeConfig = () => runtimeConfig;
